import React from 'react';
import { Page, Text, Image, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from './styles/theme';
import Logo from '../../img/EventoVirtual_LogoHorizontal.png';
import LogoGray from '../../img/EventoVirtual_LogoVertical_gray.png';

const styles = StyleSheet.create({
  page: {
    backgroundColor: colors.background.white,
  },
  // Header band
  headerBand: {
    backgroundColor: colors.background.white,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: colors.primary,
    borderBottomStyle: 'solid',
  },
  logo: {
    height: 40,
    width: 'auto',
  },
  // Main content
  body: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 60,
  },
  reportLabel: {
    fontSize: 12,
    color: colors.text.muted,
    textTransform: 'uppercase',
    letterSpacing: 2,
    marginBottom: spacing.md,
  },
  mainTitle: {
    ...typography.pageTitle,
    textAlign: 'center',
    marginBottom: spacing.xl,
  },
  decorativeLine: {
    width: 60,
    height: 3,
    backgroundColor: colors.primary,
    marginBottom: spacing.xl,
  },
  eventName: {
    fontSize: 22,
    fontWeight: 'bold',
    color: colors.text.primary,
    textAlign: 'center',
    marginBottom: spacing.lg,
  },
  dateContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.xxl,
  },
  dateLine: {
    width: 30,
    height: 1,
    backgroundColor: colors.border.medium,
  },
  dateText: {
    fontSize: 14,
    color: colors.text.secondary,
    marginHorizontal: spacing.md,
  },
  description: {
    fontSize: 11,
    color: colors.text.muted,
    textAlign: 'center',
    lineHeight: 1.6,
    maxWidth: '80%',
    marginTop: spacing.xxl,
  },
  // Footer
  footer: {
    paddingVertical: spacing.lg,
    paddingHorizontal: 60,
    borderTopWidth: 1,
    borderTopColor: colors.border.light,
    borderTopStyle: 'solid',
    alignItems: 'center',
  },
  footerText: {
    fontSize: 10,
    color: colors.text.muted,
    textAlign: 'center',
    marginBottom: spacing.sm,
  },
  footerLogo: {
    width: 50,
    height: 'auto',
    marginTop: spacing.sm,
  },
});

const TitlePage = ({
  name = 'Nombre del Evento',
  startDate = 'DD de MMMM, YYYY',
  userName = 'Usuario',
}) => {
  return (
    <Page size="LETTER" style={styles.page}>
      {/* Header Band */}
      <View style={styles.headerBand}>
        <Image style={styles.logo} src={Logo} />
      </View>

      {/* Main Content */}
      <View style={styles.body}>
        <Text style={styles.reportLabel}>Documento Oficial</Text>

        <Text style={styles.mainTitle}>INFORME DE{'\n'}AUDIENCIA Y CONEXIONES</Text>

        <View style={styles.decorativeLine} />

        <Text style={styles.eventName}>{name}</Text>

        <View style={styles.dateContainer}>
          <View style={styles.dateLine} />
          <Text style={styles.dateText}>{startDate}</Text>
          <View style={styles.dateLine} />
        </View>

        <Text style={styles.description}>
          Este informe oficial se expide por solicitud del usuario {userName},
          sintetizando las métricas y estadísticas generadas durante la
          transmisión del evento, para su respectivo análisis y documentación.
        </Text>
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <Text style={styles.footerText}>
          Informe elaborado mediante las métricas incorporadas en la plataforma
          EventoVirtual.co
        </Text>
        <Text style={styles.footerText}>www.eventovirtual.co</Text>
        <Image style={styles.footerLogo} src={LogoGray} />
      </View>
    </Page>
  );
};

export default TitlePage;
